// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calculation-sheet-wrapper {
    background: rgb(230,230,230); 
    padding: 50px;
}

.calculation-table {
    background: white;
    box-shadow: 0 0 0.5cm rgba(0,0,0,0.5);
    border-collapse: collapse;
    width: 2000px;
    white-space: nowrap;
    table-layout: fixed;
}

.calculation-table td:nth-child(5n+6) {
    background: darkgray;
}

.head-row {
    background: #eee
}

.head-row th:nth-child(5n+6) {
    background: #fbba00;
}

.calculation-table tr td:first-child {
    background: #eee;
}

.calculation-table tr:hover {
    /* background: #eee */
    outline: 1px solid gray;
}

.calculation-table td,
.calculation-table th {
    border: 1px solid lightgray;
}

.calculation-table td:hover {
    border: 1px solid lightgray;
}

.calculation-table td {
    text-align: center;
    cursor: text;
    padding: 2px;
    font-size: small;
}

.calculation-modal-cell {
    overflow-x: auto;
    cursor: text;
}

.calculation-modal-cell th:nth-child(5n+6) {
    background-color: darkgray !important;
}

.calculation-table th:first-child {
    width: 280px;
}

.calculation-table td:first-child {
    text-align: left;
    padding-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/valuation/calculationSheet/calculationSheet.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,qCAAqC;IACrC,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB","sourcesContent":[".calculation-sheet-wrapper {\n    background: rgb(230,230,230); \n    padding: 50px;\n}\n\n.calculation-table {\n    background: white;\n    box-shadow: 0 0 0.5cm rgba(0,0,0,0.5);\n    border-collapse: collapse;\n    width: 2000px;\n    white-space: nowrap;\n    table-layout: fixed;\n}\n\n.calculation-table td:nth-child(5n+6) {\n    background: darkgray;\n}\n\n.head-row {\n    background: #eee\n}\n\n.head-row th:nth-child(5n+6) {\n    background: #fbba00;\n}\n\n.calculation-table tr td:first-child {\n    background: #eee;\n}\n\n.calculation-table tr:hover {\n    /* background: #eee */\n    outline: 1px solid gray;\n}\n\n.calculation-table td,\n.calculation-table th {\n    border: 1px solid lightgray;\n}\n\n.calculation-table td:hover {\n    border: 1px solid lightgray;\n}\n\n.calculation-table td {\n    text-align: center;\n    cursor: text;\n    padding: 2px;\n    font-size: small;\n}\n\n.calculation-modal-cell {\n    overflow-x: auto;\n    cursor: text;\n}\n\n.calculation-modal-cell th:nth-child(5n+6) {\n    background-color: darkgray !important;\n}\n\n.calculation-table th:first-child {\n    width: 280px;\n}\n\n.calculation-table td:first-child {\n    text-align: left;\n    padding-left: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
